
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.385,"time":23100,"words":77}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "citer-cette-recherche"
    }}>{`Citer cette recherche`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Crépel, M., Cardon D. (2021). Criticism and prophecy in media coverage of AI. Annual Meeting of the Society for Social Studies of Science (4S), October 2021, Toronto, Canada.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Crépel, M., Do, S., Cointet J-P., Cardon, D., Bouachera, Y. (2021). Mapping AI issues in media through NLP methods. CHR2021 : Computational Humanities Research Conference, November 2021, Amsterdam, Netherlands. `}<a parentName="p" {...{
          "href": "http://ceur-ws.org/Vol-2989/long_paper22.pdf"
        }}>{`http://ceur-ws.org/Vol-2989/long_paper22.pdf`}</a></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Crépel, M., Cardon D. (2021). Critique de l’IA dans la presse. `}<a parentName="p" {...{
          "href": "https://medialab.github.io/carnet-algopresse/#/publication/fr/"
        }}>{`https://medialab.github.io/carnet-algopresse/#/publication/fr/`}</a></p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "citer-cette-recherche",
    level: 3,
    title: "Citer cette recherche",
    children: [
        
      ]
  }
]

export const frontMatter = {}

